// extracted by mini-css-extract-plugin
export default {"cart__item":"Cart_cart__item__fyx7P","counter":"Cart_counter__viV6l","delete__icon":"Cart_delete__icon__76un+"};